import React from 'react';
import {t} from 'lib/i18n';

/**
 * 푸터 > 컷 편집 영역 컴포넌트
 */

interface ICutEditWrap {
  cutTime: string;
  warning: string;
  CONVERT_LIMIT_TIME: string;
}

const CutEditWrap = ({cutTime, warning, CONVERT_LIMIT_TIME}: ICutEditWrap) => {
  return (
    <div className='cutedit_wrap'>
      <p>
        {t('컷 편집 영역')} : <span style={{color: warning}}>{cutTime}</span> /{' '}
        <span>{CONVERT_LIMIT_TIME}</span>
      </p>
    </div>
  );
};

export default CutEditWrap;
